import React from 'react';
import { Image, makeStyles, Link, Button } from '@fluentui/react-components';
import { Dismiss16Filled } from '@fluentui/react-icons';

const useStyles = makeStyles({
  appPanel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
    padding: '10px',
    columnGap: '10px',
    '&__icon': {
      marginRight: '10px',
    },
    '&__content': {
      display: 'flex',
      flexDirection: 'column',
    },
    '&__title': {
      fontSize: '16px',
      fontWeight: 'bold',
    },
    '&__description': {
      fontSize: '14px',
    },
  },
});

export const AppPanel = ({
  selectedApp,
  readOnly,
  onRemoveApp,
}) => {
  const {
    AppTitle,
    IconUrl,
    DeveloperName,
    AppUrl,
    AppStoreId,
  } = selectedApp;

  const classes = useStyles();
  const FinalAppUrl = AppUrl || `https://apps.microsoft.com/detail/${AppStoreId}`;

  return (
    <div className="app-panel" style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div className={classes.appPanel}>
        <div className="app-panel__icon">
          <Image height="64" width="64" src={IconUrl} />
        </div>
        <div className="app-panel__content">
          <div className="app-panel__title">
            {AppTitle}
          </div>
          <div className="app-panel__description">
            <Link href={FinalAppUrl} inine target="_blank"> {AppStoreId} </Link> - {DeveloperName}
          </div>
        </div>
      </div>
      { !readOnly && <Button
        icon={<Dismiss16Filled />}
        appearance="transparent"
        onClick={onRemoveApp}
      /> }
    </div>
  );
};
